import { useEffect } from 'react';
import useReactRouter from 'use-react-router';
export const ScrollToTop = () => {
    const { location } = useReactRouter();
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location.pathname]);
    return null;
};
